import React, { useState, useEffect, useRef } from "react";
import { Layout, Row, Col, Typography, Button } from "antd";
import {
  ReloadOutlined,
  FileTextOutlined,
  ClearOutlined,
} from "@ant-design/icons";
import { useLocation, useHistory } from "react-router-dom";
import DashboardFilter from "../DashboardFilters";
import { useSelector } from "react-redux";
import * as selectors from "../DashboardFilters/selectors";
import LiveOrderFunnelTracker from "../../../../components/Backoffice/LiveTracking";
import SamplingTrackingSummary from "../../../../components/Backoffice/SamplingTrackingSummary";
import CommoditySamplingSummaryView from "../../../../components/Backoffice/CommoditySamplingSummary";
import TestingAnalyticsSummary from "../../../../components/Backoffice/TestingAnalyticsSummary";
import TATMonitoringSummary from "../../../../components/Backoffice/TATSummary";
import { useAuth } from "../../../../contexts/auth";
import IndiaMap from "../../../../components/Backoffice/SamplingCoverageMap";
import RegretDashboard from "../../../../components/Backoffice/RegretCaseSummary";
import OverallCompliance from "../../../../components/Backoffice/OverallComplaince";
import ComplianceSummary from "../../../../components/Backoffice/ParameterCompliance";
import CommodityCompliance from "../../../../components/Backoffice/CommodityCompliance";
const { Header, Content } = Layout;
const { Title } = Typography;

const DashboardNew = () => {
  const history = useHistory();
  const location = useLocation();
  const auth = useAuth();
  const user = auth.loggedInUser;
  const refreshIntervalRef = useRef(null);
  const userRole = user?.role;
  const companyId = user?.company?._id;
  const locationFilters = location.state?.filters;
  const rawProjects = useSelector(selectors.selectRawProjects);

  const [activeTab, setActiveTab] = useState("live");
  const [selectedClients, setSelectedClients] = useState(
    locationFilters?.companyIds || []
  );
  const [selectedProjects, setSelectedProjects] = useState(
    locationFilters?.projectCodeIds || []
  );
  const [parameterRequest, setParameterRequest] = useState(locationFilters?.parameterRequest || "overall");
  const [refreshKey, setRefreshKey] = useState(0);

  const filters = {
    companyIds: selectedClients,
    projectCodeIds: selectedProjects,
    parameterRequest: parameterRequest
  };

  // Auto-refresh every 5 minutes
  useEffect(() => {
    refreshIntervalRef.current = setInterval(() => {
      setRefreshKey((prev) => prev + 1);
    }, 5 * 60 * 1000); // 5 minutes

    return () => {
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
      }
    };
  }, []);

  const handleClientChange = (newSelectedClients) => {
    setSelectedClients(newSelectedClients);

    if (newSelectedClients.length === 0) {
      setSelectedProjects([]);
    } else {
      const validProjects = selectors.getValidProjects(
        selectedProjects,
        newSelectedClients,
        rawProjects
      );
      setSelectedProjects(validProjects);
    }
  };

  const handleProjectChange = (value) => {
    setSelectedProjects(value);
  };

  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const handleResetFilters = () => {
    setSelectedClients([]);
    setSelectedProjects([]);
  };

  const handleDetailedClick = () => {
    history.push("/bo/dashboard/details?type=sampling", { filters });
  };

  const handleCommodityDetailedClick = () => {
    history.push("/bo/dashboard/details?type=commodity", { filters });
  };

  const handleTestingDetailedClick = () => {
    history.push("/bo/dashboard/details?type=testing", { filters });
  };

  const handleTATDetailedClick = () => {
    history.push("/bo/dashboard/details?type=tat", { filters });
  };

  const handlemapDetailedClick = () => {
    history.push("/bo/dashboard/details?type=map", { filters });
  };

  const handleComplianceMapDetailedClick = (dimension) => {
    // history.push("/bo/dashboard/details?type=compliance-map", {
    //   filters,
    //   dimension: dimension
    // });
  };

  const handleParamComplianceDetailedClick = () => {
    history.push("/bo/dashboard/details?type=param", { filters });
  };

  const handleRegretDetailedClick = () => {
    history.push("/bo/dashboard/details?type=regret", { filters });
  };

  const handleCommodityComplianceDetailedClick = () => {
    history.push("/bo/dashboard/details?type=commodity-compliance", { filters });
  };

  const handleReportClick = () => {
    history.push("/bo/dashboard/report");
  };

  const handleParameterRequest = (value) => {
    setParameterRequest(value);
  }; 


  useEffect(() => {
    if (companyId) {
      setSelectedClients([companyId]);
    }
  }, [companyId]);

  return (
    <Layout>
      <Content style={{ padding: 24 }}>
        <Header style={{ background: "#0D9488", padding: "0 20px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Title level={4} style={{ color: "#fff", margin: 0 }}>
              Dashboard
            </Title>
            <div>
              {userRole !== "csc_admin" && (
                <Button
                  onClick={handleReportClick}
                  icon={<FileTextOutlined />}
                  style={{ marginRight: 8 }}
                >
                  Reports
                </Button>
              )}
              <Button
                onClick={handleRefresh}
                icon={<ReloadOutlined />}
                style={{ marginRight: 8 }}
              >
                Refresh
              </Button>
              <Button onClick={handleResetFilters} icon={<ClearOutlined />}>
                Reset Filters
              </Button>
            </div>
          </div>
        </Header>

        <DashboardFilter
          selectedClients={selectedClients}
          selectedProjects={selectedProjects}
          handleClientChange={handleClientChange}
          handleProjectChange={handleProjectChange}
          currentView={activeTab}
          parameterRequest={parameterRequest}
          handleParameterRequest={handleParameterRequest}
        />

        <div
          style={{
            display: "flex",
            marginTop: 24,
            border: "1px solid #D9D9D9",
            borderRadius: 8,
            overflow: "hidden",
            width: "100%",
          }}
        >
          <div
            onClick={() => setActiveTab("live")}
            style={{
              flex: 1,
              textAlign: "center",
              padding: "12px 0",
              cursor: "pointer",
              backgroundColor: activeTab === "live" ? "#fff" : "#F5F7FA",
              border: activeTab === "live" ? "2px solid #000" : "none",
              fontWeight: activeTab === "live" ? "600" : "400",
              borderRadius: activeTab === "live" ? "8px" : "0px",
              margin: activeTab === "live" ? "2px" : "0px",
            }}
          >
            Live Tracking
          </div>
          <div
            onClick={() => setActiveTab("compliance")}
            style={{
              flex: 1,
              textAlign: "center",
              padding: "12px 0",
              cursor: "pointer",
              backgroundColor: activeTab === "compliance" ? "#fff" : "#F5F7FA",
              border: activeTab === "compliance" ? "2px solid #000" : "none",
              fontWeight: activeTab === "compliance" ? "600" : "400",
              borderRadius: activeTab === "compliance" ? "8px" : "0px",
              margin: activeTab === "compliance" ? "2px" : "0px",
            }}
          >
            Compliance
          </div>
        </div>

        {/* Tab Content */}
        {activeTab === "live" && (
          <>
            <LiveOrderFunnelTracker
              key={`funnel-${refreshKey}`}
              filters={filters}
              onSuccess={() => {}}
              onFailure={(err) => console.error("Funnel fetch error", err)}
            />
            <Row gutter={24} style={{ marginTop: 24 }}>
              <Col span={12}>
                {userRole !== "company_admin" &&
                  userRole !== "regulatory_body_admin" && (
                    <SamplingTrackingSummary
                      key={`sampling-${refreshKey}`}
                      filters={filters}
                      onDetailedClick={handleDetailedClick}
                    />
                  )}
              </Col>
              <Col
                span={
                  userRole !== "company_admin" &&
                  userRole !== "regulatory_body_admin"
                    ? 12
                    : 24
                }
              >
                <CommoditySamplingSummaryView
                  key={`commodity-${refreshKey}`}
                  filters={filters}
                  onDetailedClick={handleCommodityDetailedClick}
                />
              </Col>
            </Row>
            <Row gutter={24} style={{ marginTop: 24 }}>
              {userRole !== "company_admin" &&
                userRole !== "regulatory_body_admin" && (
                  <Col span={12}>
                    <RegretDashboard
                      key={`regret-${refreshKey}`}
                      filters={filters}
                      onDetailedClick={handleRegretDetailedClick}
                    />
                  </Col>
                )}
              <Col
                span={
                  userRole !== "company_admin" &&
                  userRole !== "regulatory_body_admin"
                    ? 12
                    : 24
                }
              >
                <TATMonitoringSummary
                  key={`tat-${refreshKey}`}
                  filters={filters}
                  onDetailedClick={handleTATDetailedClick}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 24 }}>
              <Col span={24}>
                <TestingAnalyticsSummary
                  key={`testing-${refreshKey}`}
                  filters={filters}
                  onDetailedClick={handleTestingDetailedClick}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 24 }}>
              <Col span={24}>
                <IndiaMap
                  key={`map-${refreshKey}`}
                  filters={filters}
                  onDetailedClick={handlemapDetailedClick}
                  mapType="sampling"
                />
              </Col>
            </Row>
          </>
        )}

        {activeTab === "compliance" && (
          <>
            <OverallCompliance
              key={`compliance-${refreshKey}`}
              filters={filters}
            />
            <Row style={{ marginTop: 24 }}>
              <Col span={24}>
                <IndiaMap
                  filters={filters}
                  onDetailedClick={handleComplianceMapDetailedClick}
                  mapType="compliance"
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 45 }}>
              <Col span={24}>
                <ComplianceSummary
                  key={`param-compliance-${refreshKey}`}
                  filters={filters}
                  onDetailedClick={handleParamComplianceDetailedClick}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 45 }}>
              <Col span={24}>
                <CommodityCompliance
                  key={`commodity-compliance-${refreshKey}`}
                  filters={filters}
                  onDetailedClick={handleCommodityComplianceDetailedClick}
                />
              </Col>
            </Row>
          </>
        )}
      </Content>
    </Layout>
  );
};

export default DashboardNew;